import { useIsMobile } from '../../../hooks/useIsMobile';
import { CHART_CONFIG } from '../config';

type MarginVariant = keyof typeof CHART_CONFIG.MARGINS;
type HeightVariant = keyof typeof CHART_CONFIG.MOBILE_HEIGHTS;

/**
 * Central hook for responsive chart configuration.
 * - Use `isMobile` for chart-specific conditional rendering.
 * - Use `getMargins(variant)` to get the canonical margin set for mobile or desktop.
 * - Use `getHeight(desktopHeight, variant?)` to get a responsive chart height.
 *
 * Add new breakpoint logic here rather than in individual chart files.
 */
export function useResponsiveChartConfig() {
  const isMobile = useIsMobile();
  const isNarrow = useIsMobile(1024);

  const getMargins = (variant: MarginVariant = 'DEFAULT') =>
    isMobile ? CHART_CONFIG.MOBILE_MARGINS[variant] : CHART_CONFIG.MARGINS[variant];

  const getHeight = (desktopHeight: number, variant?: HeightVariant): number => {
    if (!isMobile) return desktopHeight;
    return variant ? CHART_CONFIG.MOBILE_HEIGHTS[variant] : Math.round(desktopHeight * 0.65);
  };

  return { isMobile, isNarrow, getMargins, getHeight };
}
